export const AWS_S3_URL = "https://raffle-house-staging.s3-eu-west-1.amazonaws.com/";
export const AWS_S3_URL_PROD = "https://raffle-house-production.s3-eu-west-1.amazonaws.com/";
